import PrimeOnboardingNotCompletedContainer from "./PrimeOnboardingNotCompletedContainer";
import PrimeOnboardingNotCompletedStore from "./PrimeOnboardingNotCompletedStore";

export default PrimeOnboardingNotCompletedStore(PrimeOnboardingNotCompletedContainer);